// Auth Service för att hantera JWT-tokens och cookies
class AuthService {
  constructor() {
    this.tokenKey = 'wishlist_token';
  }

  // Spara token i cookie
  setToken(token) {
    // Beräkna utgångsdatum (24 timmar från nu)
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (24 * 60 * 60 * 1000));
    
    document.cookie = `${this.tokenKey}=${token}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Strict`;
  }

  // Hämta token från cookie
  getToken() {
    const name = this.tokenKey + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  }

  // Ta bort token från cookie
  removeToken() {
    document.cookie = `${this.tokenKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  // Kontrollera om token är giltig
  isTokenValid(token = null) {
    const tokenToCheck = token || this.getToken();
    
    if (!tokenToCheck) {
      return false;
    }

    try {
      // Dekoda JWT payload för att kontrollera utgångsdatum
      const payload = JSON.parse(atob(tokenToCheck.split('.')[1]));
      const currentTime = Date.now() / 1000;
      
      // Kontrollera om token har gått ut
      if (payload.exp && payload.exp < currentTime) {
        this.removeToken(); // Ta bort utgången token
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('Token validation failed:', error);
      this.removeToken(); // Ta bort ogiltig token
      return false;
    }
  }

  // Kontrollera om användaren är inloggad
  isAuthenticated() {
    return this.isTokenValid();
  }

  // Avkoda JWT-payloaden (utan signaturvalidering – bara för UI-hintar)
  getClaims() {
    const token = this.getToken();
    if (!token) return null;
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  }

  // Är den inloggade användaren admin? (bärs i JWT-claimen is_admin)
  isAdmin() {
    const claims = this.getClaims();
    return !!(claims && claims.is_admin);
  }

  // Logga ut användaren
  logout() {
    this.removeToken();
  }

  // Automatisk token-validering och cleanup
  validateAndCleanupToken() {
    const token = this.getToken();
    if (token && !this.isTokenValid(token)) {
      this.removeToken();
      return false;
    }
    return !!token;
  }
}

export default new AuthService();
